// Local translations
export const T = {
  en_GB: {
    cropPreview: "Crop preview",
    changePhoto: "Change Photo",
    pngOrJpgMax5MB: "PNG or JPG, max 5MB",
    selectPngOrJpg: "Please select a PNG or JPG image",
    imageTooLarge: "Image must be less than 5MB",
    failedToCrop: "Failed to crop image",
    failedToUpload: "Failed to upload image",
    failedToSavePhoto: "Failed to save profile picture",
    cropProfilePicture: "Crop Profile Picture",
    dragToReposition: "Drag to reposition and resize the crop area",
    cancel: "Cancel",
    save: "Save",
  },
  nb_NO: {
    cropPreview: "Forhåndsvisning av beskjæring",
    changePhoto: "Endre bilde",
    pngOrJpgMax5MB: "PNG eller JPG, maks 5 MB",
    selectPngOrJpg: "Velg et PNG- eller JPG-bilde",
    imageTooLarge: "Bildet må være mindre enn 5 MB",
    failedToCrop: "Kunne ikke beskjære bildet",
    failedToUpload: "Kunne ikke laste opp bildet",
    failedToSavePhoto: "Kunne ikke lagre profilbildet",
    cropProfilePicture: "Beskjær profilbilde",
    dragToReposition: "Dra for å flytte og justere beskjæringsområdet",
    cancel: "Avbryt",
    save: "Lagre",
  },
} as const;
